import { createContext, useContext } from 'react';

export const ErrorContext = createContext({
  error: null,
  clearErrorMessages(...errorMessagesToClear) {},
});

const useErrorHandling = () => {
  const { error, clearErrorMessages } = useContext(ErrorContext);

  return [error, { clearErrorMessages }];
};

export default useErrorHandling;
